// extracted by mini-css-extract-plugin
module.exports = {"bb-publications":"bb-publications__Dsz8N","wrapper":"wrapper__2XpPT"};